import styled from "styled-components";

const TodosWrapper = styled.section`
  background-color: var(--todo-BG);
  padding: 1rem 3rem;
  margin-top: 3rem 0;
  grid-column: 2/3;
  grid-row: 4/5;
  border-radius: 3px;
  overflow: hidden;
  min-height: 50vh;
  min-width: 60rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: 700px) {
    min-width: 90vw;
  }

  & .empty__todos {
    margin: auto;
    font-size: 2.5rem;
    text-transform: capitalize;
    color: var(--text);
  }
`;

export default TodosWrapper;
